import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import TextInput from 'Components/Forms/Elements/TextInput';
import { action } from 'Shared/Routes';
export default function SearchcityField(props) {
  const [value, setValue] = useState('');
  const [results, setResults] = useState(undefined);
  const [fetching, setFetching] = useState(false);
  const [token, setToken] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(-1); // nothing selected

  const input_ref = useRef(null);
  useEffect(() => {
    if (!props['initial-value']) return;
    const {
      value = '',
      label = ''
    } = props['initial-value'];
    setValue(value);
    fetchResults(value);
    pickCity(null, {
      label: label,
      value: value
    });
  }, []);
  useEffect(() => {
    if (fetching !== true) return;
    if (token) token.cancel();
    fetchResults();
  }, [value]);
  const cities = (results || []).map(function (city, i) {
    const output = /*#__PURE__*/React.createElement("li", {
      className: "c-widget__city",
      key: city.label
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => pickCity(e, city),
      className: 'c-widget__city-btn' + (hovered === i ? ' is-active' : '')
    }, city.label));
    return output;
  });
  const output = /*#__PURE__*/React.createElement("div", {
    className: 'c-widget__searched' + (' ' + (props.className || '').trim())
  }, !value && props.placeholder ? /*#__PURE__*/React.createElement("span", {
    className: "c-widget-select__placeholder"
  }, props.placeholder) : undefined, /*#__PURE__*/React.createElement(TextInput, {
    className: "c-widget__select",
    name: props.name,
    onChange: handleChange,
    onBlur: e => {
      setVisible(false);
      setHovered(-1);
    },
    onFocus: e => setVisible(true),
    onKeyDown: e => handleKeyDown(e),
    value: value,
    id: props.id,
    status: props.status,
    "input-ref": input_ref,
    autoComplete: "off",
    "aria-labelledby": props['aria-labelledby']
  }), results === undefined || results.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: 'c-widget__cities-wrapper' + (visible ? ' is-visible' : '')
  }, /*#__PURE__*/React.createElement("ul", {
    className: "c-widget__cities"
  }, cities, results !== undefined && results.length === 0 ? /*#__PURE__*/React.createElement("li", {
    className: "c-widget__city is-info"
  }, "Aucun r\xE9sultat.") : undefined)) : results);
  return output;
  function handleChange({
    ...params
  }) {
    if (value === params.value) return;
    props.onChange({
      e: params.e,
      value: '',
      name: props.name
    });
    if (props.onType) props.onType(params.e);
    setValue(params.value);
    if (fetching === false) {
      setFetching(true);
    }
  }
  function pickCity(e, city) {
    setValue(city.value.split('#')[0]);
    props.onChange({
      e: e,
      value: city,
      name: props.name
    });
  }
  async function fetchResults(custom) {
    const searched = typeof custom !== 'undefined' ? custom : value;
    if (!searched || searched.length < 2) return;
    if (fetching !== true) setFetching(true);
    setToken(axios.CancelToken.source());
    try {
      var {
        data: response
      } = await axios.post(action('AutocompleteCity'), {
        searched: searched
      });
      setToken(undefined);
      setFetching(false);
      setHovered(-1);
      setResults(response.data || []);
    } catch (e) {
      setToken(undefined);
      setFetching(false);
      setHovered(-1);
      return console.error(e?.error || e);
    }
  }
  function handleKeyDown(e) {
    let new_value = hovered;
    if (e.keyCode === 27)
      // esc
      {
        return input_ref?.current?.blur?.();
      } else if (e.keyCode === 13)
      // enter
      {
        e?.preventDefault?.();
        const city = results[hovered];
        if (!city) return;
        e?.persist?.();
        setVisible(false);
        setHovered(-1);
        return pickCity(e, city);
      } else if (e.keyCode === 40)
      // arrow down
      {
        new_value += 1;
      } else if (e.keyCode === 38)
      // arrow up
      {
        new_value -= 1;
      } else {
      return;
    }

    // -1 is the stating index, nothing is selected
    if (new_value < -1) return;
    if (new_value > results.length - 1) return;
    if (new_value !== hovered) setHovered(new_value);
  }
}
